<dl class="confirmation-dl">
  @for (entry of entries; track entry) {
    @if (entry.value) {
      <dt class="confirmation-dl__dt">{{ entry.label }}</dt>
    }
    @if (entry.value) {
      <dd class="confirmation-dl__dd">
        {{ entry.value }}
      </dd>
    }
  }
</dl>
